import React from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import {useTranslation} from 'react-i18next'
import Address from '../../../Api/SettingAddress'
import {format, parseISO} from 'date-fns'
import {Container, Stack, Typography} from '@mui/material'
import Logo from '../../../svg/Logo'
import NameText from '../../customTable/NameText'
import FixedNumber from '../../customTable/FixedNumber'
import Label from '../../customTable/Label'

export default function InvoEn({invoiceData}: any) {
  const store = useSelector((state: RootState) => state.vender)
  const currency = localStorage.getItem('currency')
  console.log(invoiceData)

  const {t} = useTranslation()
  return (
    <Container maxWidth='lg'>
      <Stack width='100%' dir={store.isRtl === 0 ? 'ltr' : 'rtl'} className={`container invo `}>
        <div className='head'>
          <div className='flex-c d-block d-sm-none'>
            <div className='d-flex flex-column justify-content-center align-items-center'>
              <img className='invoice-logo' src={store.StoreImage} alt='invoice-logo' />

              <p className='bold text-center fs-18-med'>
                {invoiceData.store_name && invoiceData.store_name[store.lang]}
              </p>
            </div>
          </div>
          <div className='flex flex-column flex-sm-row'>
            <div className='flex-c'>
              <h2 className='invoice text-center text-sm-start'>{t('invoice')}</h2>
              <p className='bold text-center text-sm-start fs-18-med'>
                {invoiceData.created_at}
                {/* {invoiceData.created_at && format(parseISO(invoiceData.created_at), 'yyyy-MM-dd')} */}
              </p>
              <p className='bold text-center text-sm-start fs-18-med'>
                {t('invoiceID')}: {invoiceData && invoiceData.order_number}
              </p>
            </div>
            <div className='flex-c d-none d-sm-block'>
              <img className='invoice-logo' src={store.StoreImage} alt='invoice-logo' />
              <p className='bold text-center fs-18-med'>
                {' '}
                {invoiceData.name && invoiceData.name[store.lang]}
              </p>
            </div>
            <div className='flex-c'>
              <h2 style={{textAlign: 'end'}} className='totalPricing'>
                <Stack alignItems={{xs: 'center', sm: 'flex-end'}}>
                  <FixedNumber num={invoiceData.total} />
                </Stack>
              </h2>
              <p style={{textAlign: 'end'}} className='bold   fs-18-med'>
                {t('paymentMethod')} :{' '}
                {invoiceData.payment_method &&
                  (invoiceData.payment_method[store.lang] ||
                    invoiceData.payment_method[store.defLang])}
              </p>
              <p style={{textAlign: 'end'}} className='bold   fs-18-med'>
                {t('shippedBy')}:{' '}
                {invoiceData && invoiceData.vendor && invoiceData.vendor.store_name}
              </p>
            </div>
          </div>
        </div>
        <div className='sec'>
          <div className='flex align-items-flex-start'>
            <div className='flex-c'>
              <span className='ft-poppins-med text-2d'>{t('from')} :</span>
              <p className='ft-poppins-med text-2d'>
                {invoiceData && invoiceData.vendor && invoiceData.vendor.store_name}
              </p>
              <p className='ft-poppins-med text-2d'>
                {invoiceData && invoiceData.vendor && invoiceData.vendor.store_email}
              </p>
              <p className='ft-poppins-med text-2d'>
                {invoiceData && invoiceData.vendor && invoiceData.vendor.store_mobile}
              </p>
              <p className='ft-poppins-med text-2d max-w-420px'>
                Address :
                {invoiceData && invoiceData.vendor && invoiceData.vendor.store_street_address}
              </p>
            </div>
            <Stack minWidth={{md: '320px'}} className='flex-c'>
              <span className='ft-poppins-med text-2d'>{t('to')} :</span>
              <p className='ft-poppins-med text-2d'>
                {invoiceData && invoiceData.user && invoiceData.user.full_name}
              </p>
              <p className='ft-poppins-med text-2d'>
                {invoiceData && invoiceData.user && invoiceData.user.email}
              </p>
              <p className='ft-poppins-med text-2d'> {invoiceData && invoiceData.address_phone}</p>
              <p className='ft-poppins-med text-2d max-w-420px'>
                {t('shippingAddress')} : {invoiceData.address_full_name}
              </p>
            </Stack>
          </div>
        </div>
        <div className='table'>
          <table>
            <thead>
              <tr>
                <th className='text-web fs-18-med  max-w-600px min-w-300px web-auto'>
                  {t('yourOrder')}
                </th>
                <th className='text-web fs-18-med min-w-150px max-w-262px'>{t('sku')}</th>
                <th className='text-web fs-18-med min-w-150px max-w-262px'>{t('quantity')}</th>
                <th className='text-web pl-20 min-w-150px fs-18-med'>{t('unitPrice')}</th>
                <th className='text-web pl-20 min-w-150px fs-18-med'>
                  <Stack>
                    <p className='text-web pl-20 min-w-150px fs-18-med'>{t('subTotal')}</p>
                    <Label text='beforeDiscount' />
                  </Stack>
                </th>
                <th className='text-web text-right min-w-150px fs-18-med'>
                  {' '}
                  <Stack>
                    <p className='text-web pl-20 min-w-150px fs-18-med'>{t('total')}</p>
                    <Label text='afterDiscount' />
                  </Stack>{' '}
                </th>
              </tr>
            </thead>
            <tbody>
              {invoiceData.order_items &&
                invoiceData.order_items.map((e: any, i: any) => (
                  <tr key={i}>
                    <td className='text-left'>
                      <div className='flex justify-content-start align-items-start'>
                        <div className='flex-c'>
                          <span className='product-name ft-poppins-reg'>{e.name} </span>

                          <div className='pl-fr '>
                            {e.product &&
                              e.product.order_options &&
                              e.product.order_options.map((a: any, i: any) => (
                                <Stack direction={'row'} gap='5px' alignItems={'center'}>
                                  <Typography key={i} sx={{color: 'var(--bs-body-color)'}}>
                                    {a.name && (a.name[store.lang] || a.name[store.defLang])}{' '}
                                  </Typography>
                                  :{' '}
                                  <Typography style={{color: 'var(--bs-text-gray-700)'}}>
                                    {
                                      a.value &&
                                      (a.value[store.lang] || a.value[store.defLang]).includes(
                                        'https://'
                                      ) ? (
                                        <a
                                          style={{color: '#03a9f4'}}
                                          target={'_blank'}
                                          href={a.value}
                                          rel='noreferrer'
                                        >
                                          {' '}
                                          {t('link')}{' '}
                                        </a>
                                      ) : (
                                        a.value && (a.value[store.lang] || a.value[store.defLang])
                                      )
                                      //  &&
                                      // (e.option_value[store.lang] || e.option_value[store.defLang])
                                    }
                                  </Typography>
                                </Stack>
                              ))}{' '}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style={{textAlign: 'start'}}>
                      {' '}
                      {t('sku')}: {e.product && e.product.sku}
                    </td>
                    <td style={{textAlign: 'start'}}>
                      {e.quantity}{' '}
                      {/* {e.bulk_discount_amount === 0 &&
                        `(${e.bulk_discount_amount} ${t(`bulkDiscount`)}) `} */}
                    </td>
                    <td style={{textAlign: 'start'}} className='pl-20'>
                      {currency}
                      <span className='bold fs-18px'>{e.unit_price}</span>
                    </td>
                    <td style={{textAlign: 'start'}} className='pl-20'>
                      {currency}
                      <span className='bold fs-18px'>{e.sub_total}</span>
                    </td>
                    <td style={{textAlign: 'start'}} className='text-right'>
                      {currency}
                      <span className='bold fs-18px'>{e.total}</span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className='billing'>
          <div className='flex-c billingDetails'>
            <h3 style={{marginBottom: '15px'}} className='bold ft-poppins-med'>
              {t('billingSummary')}
            </h3>
            <Stack
              justifyContent={'space-between'}
              direction={'row'}
              maxWidth={'300px'}
              width={'100%'}
            >
              <Typography className='text-gray fs-14px'>{t('subTotal')}</Typography>
              <Typography className='fs-15-med '>
                <FixedNumber num={invoiceData.sub_total} />
              </Typography>
            </Stack>

            <Stack
              justifyContent={'space-between'}
              direction={'row'}
              maxWidth={'300px'}
              width={'100%'}
              alignItems={'center'}
            >
              <Typography className='text-gray fs-14px'>{t('discount')}</Typography>
              <Stack direction={'row'} gap='5px' className='fs-15-med '>
                {/* {invoiceData.total !== invoiceData.sub_total && '-'}{' '} */}
                <FixedNumber num={invoiceData.discount || 0} />
              </Stack>
            </Stack>
            <Stack
              justifyContent={'space-between'}
              direction={'row'}
              maxWidth={'300px'}
              width={'100%'}
            >
              <Typography className='text-gray fs-14px'>{t('coupon')}</Typography>
              <Typography className='fs-15-med '>
                <FixedNumber num={invoiceData.coupon_discount_amount} />
              </Typography>
            </Stack>
            <Stack
              justifyContent={'space-between'}
              direction={'row'}
              maxWidth={'300px'}
              width={'100%'}
            >
              <Typography className='text-gray fs-14px'>{t('shipping')}</Typography>
              <Typography className='fs-15-med '>
                <FixedNumber num={invoiceData.shipping_cost} />
              </Typography>
            </Stack>
            <Stack
              justifyContent={'space-between'}
              direction={'row'}
              maxWidth={'300px'}
              width={'100%'}
            >
              <Typography className='text-gray fs-14px'>{t('tax')}</Typography>
              <Typography className='fs-15-med '>
                <FixedNumber num={invoiceData.tax} />
              </Typography>
            </Stack>

            <div
              style={{borderTop: '1px solid #e0e0e0', marginTop: '8px', paddingTop: '8px'}}
              className='flex'
            >
              <p style={{fontWeight: '800'}} className='bold'>
                {t('grandTotal')}
              </p>
              <p style={{fontWeight: '800'}} className='bold '>
                <FixedNumber fw='600' num={invoiceData.total} />
              </p>
            </div>
            {currency == '$' && (
              <p style={{fontSize: '14px', textAlign: 'end'}}>
                {t('OrItsEquivalentInLocalCurrency')}{' '}
              </p>
            )}
          </div>
        </div>
        <div className='footer'>
          <div className='flex-c'></div>
        </div>
      </Stack>
    </Container>
  )
}
